<template>
    <div class="no-container padding-normal">
        <div v-if="visualBlock" class="relative bg-cover">
            <p class="text-darkgray text-lg font-bold lg:text-2xl">
                {{ visualBlock.label }}
            </p>
            <div>
                <video
                    ref="videoRef"
                    v-if="videoUrl"
                    class="h-[70vh] w-screen object-cover"
                    :controls="isPlaying"
                    @play="isPlaying = true">
                    <source :src="videoUrl" type="video/mp4" />
                    Uw browser ondersteunt de videotag niet.
                </video>
                <div
                    v-if="!isPlaying && visualBlock.video"
                    class="absolute inset-0 flex cursor-pointer items-center justify-center"
                    @click="playVideo">
                    <NuxtImg
                        v-if="visualBlock.video"
                        src="/play-button.png"
                        width="150"
                        height="150"
                        class="w-10 rounded-lg opacity-70 sm:w-14 md:w-20 lg:w-28 xl:w-32"
                        alt="Play video"
                        sizes="100vw sm:50vw md:400px" />
                </div>
            </div>
            <!-- Bounded renditions straight from the Sanity CDN: the untransformed originals are
                 multi-MP scans that iOS Safari refuses to decode under memory pressure (images
                 "not loading" on iPad). Plain <img> with a hand-built srcset — NuxtImg generates
                 invalid "1w/2w" width descriptors for external URLs, which breaks Safari. -->
            <img
                v-if="visualBlock.media && visualBlock.media.asset"
                :src="mediaSrc(1600)"
                :srcset="`${mediaSrc(800)} 800w, ${mediaSrc(1200)} 1200w, ${mediaSrc(1600)} 1600w`"
                :alt="alt"
                :class="imageClass"
                sizes="100vw"
                class="h-auto max-h-[100vh]" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { vercelStegaCleanAll } from '@sanity/client/stega';

    const props = defineProps({
        visualBlock: Object,
        videoUrl: String,
        Theme: String,
        alt: String,
        label: String,
        content: String,
        link: String,
        button: Object,
    });

    const videoRef = ref(null);
    const isPlaying = ref(false);

    // Sanity caps w= at the original size, so small originals are served as-is (no upscale)
    const mediaSrc = (width: number) => useImageUrl(props.visualBlock.media).format('webp').width(width).url();

    const playVideo = () => {
        videoRef.value.play();
    };

    const imageClass = computed(() => {
        // NOTE: the aspect-w-*/aspect-h-* classes come from the aspect-ratio plugin, which is not
        // installed — they emit nothing. Kept out deliberately: the images render at natural ratio.
        switch (props.visualBlock.imageFormat) {
            case 'square':
                return 'w-full lg:w-auto object-contain lg:object-cover mx-auto';
            case 'rectangleHorizontal':
                return 'object-contain lg:object-cover w-full';
            case 'rectangleVertical':
                return 'object-contain lg:object-cover mx-auto';
            default:
                return 'object-contain lg:object-cover w-full';
        }
    });
</script>
